<template>
  <a-modal
    title="评论回复"
    :width="500"
    :visible="visible"
    :maskClosable="false"
    @ok="handleOk"
    @cancel="handleCancel"
    :bodyStyle="{'padding':'10px 25px'}"
  >
    <div class="game-setting-page">
      <a-form :form="form">
        <a-row>
          <a-col :span="24">
            <a-form-item
              style="margin-bottom:12px;line-height:1"
              :label-col="{ span: 4 }"
              :wrapper-col="{ span: 20 }"
              label="回复内容：   "
            >
              <a-textarea
                style="height:100px;"
                placeholder="请输入回复"
                v-decorator="[
                  'replyDetail',
                  {rules: [{ required: true, message: '请输入回复内容' }]}
                ]" />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
  </a-modal>
</template>

<script>
// import moment from 'moment'
// import pick from 'lodash.pick'
// import { FormTypes } from '@/utils/JEditableTableUtil'
// import { JEditableTableMixin } from '@/mixins/JEditableTableMixin'

import Vue from "vue";

import pick from "lodash.pick";

import { updCourseComment } from "@/api/api";

export default {
  name: "GameTypeSelectModal",
  mixins: [],
  props: {},
  data() {
    return {
      replyDetail: "",
      visible:false,
      form: this.$form.createForm(this)
    };
  },
  methods: {
    
   
    handleOk() {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.visible = false;
          // alert();

          let param = {...values,"busiNo":"updCourseComment",id:this.plid}

          updCourseComment(param).then((res)=>{   
            if(res.success==true){
              this.$message.success(res.message);
              this.$parent.loadData();
            }else{
              this.$message.warning(res.message);
            }

          }).finally(() => {
            
          })

        }
      });
      // this.visible = false;
      // if(this.selectCurType==1){
      //   this.$router.push({ path:'/myGame/gameEditor?courseId='+this.courseId+"&chapterId="+this.chapterId});
      // }
    },
    handleCancel() {
      this.visible = false;
    },
    add(id) {
      let _this = this;
      _this.visible = true;
      _this.plid = id
    }
  },
  mounted() {
    // this.getImgListData();
  },
  created() {
    
  },
  computed: {
    uploadAction: function() {
      return this.url.fileUpload;
    }
  }
};
</script>

<style lang="scss" scoped >
.game-setting-page {
  .line-data-list {
    .line-data-item {
      margin-bottom: 10px;
      .line-data-select {
        margin-right: 10px;
      }
      .del-line-data {
        color: red;
        cursor: pointer;
        margin-left: 10px;
        vertical-align: top;
        margin-top: 14px;
      }
    }
  }
}
.img-upload-list-pager {
  text-align: center;
  .ant-pagination {
    display: inline-block;
  }
}
.voice-item {
  float: left;
  margin-right: 20px;
  .voice-item-title {
    text-align: center;
    padding: 5px 0px;
  }
}
</style>